export const COURSE_ATTRIBUTES = {
  REQUIRED: 'required',
  OPTIONAL: 'optional'
}

export const BOOKMARK_COURSE_DISPLAY_TYPE = {
  GRID: 'grid',
  DEFAULT: 'list'
}

export const TYPE = {
  NEW: 'new',
  RECOMMENDED: 'recommended',
  RECENT_VIEWS: 'recentViews',
  CATEGORY: 'category',
  UNCATEGORIZED: 'uncategorized'
}

export const PARAMS = {
  NEW: 'new',
  RECOMMENDED: 'recommended',
  RECENT_VIEWS: 'recentViews',
  CATEGORY: 'category'
}
